(() => {
  if (window.__vtCarouselInit) return;
  window.__vtCarouselInit = true;

  const PER_PAGE = 4;
  const desktop = window.matchMedia('(min-width: 1024px)');

  const init = (root) => {
    const track = root.querySelector('[data-vt-track]');
    const prev = root.querySelector('[data-vt-prev]');
    const next = root.querySelector('[data-vt-next]');
    const more = root.querySelector('[data-vt-more]');
    if (!track || !prev || !next) return;

    let page = 0;
    let visible = PER_PAGE;

    const items = () => Array.from(track.children).filter((el) => !el.hasAttribute('data-vt-more'));
    const pages = () => Math.max(1, Math.ceil(items().length / PER_PAGE));

    function applyMobileVisibility() {
      const cards = items();
      cards.forEach((card, i) => card.classList.toggle('vt-hidden', i >= visible));
      if (more) more.hidden = visible >= cards.length;
    }

    function render() {
      if (desktop.matches) {
        if (page >= pages()) page = 0;
        const first = items()[page * PER_PAGE];
        track.style.transform = first ? `translateX(${-first.offsetLeft}px)` : '';
        prev.hidden = page === 0;
        next.hidden = pages() <= 1;
        if (more) more.hidden = true;
      } else {
        track.style.transform = '';
        prev.hidden = true;
        next.hidden = true;
        applyMobileVisibility();
      }
    }

    next.addEventListener('click', () => {
      if (!desktop.matches) return;
      page = (page + 1) % pages();
      render();
    });
    prev.addEventListener('click', () => {
      page = Math.max(0, page - 1);
      render();
    });

    if (more) {
      more.addEventListener('click', () => {
        const firstNewIndex = visible;
        visible = Math.min(visible + PER_PAGE, items().length);
        applyMobileVisibility();
        const target = items()[firstNewIndex];
        if (target) {
          const left =
            target.getBoundingClientRect().left -
            track.getBoundingClientRect().left +
            track.scrollLeft -
            40;
          track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      });
    }

    window.addEventListener('resize', render, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', render);
    render();
  };

  document.querySelectorAll('[data-vt-carousel]').forEach(init);
})();
